import { useTranslation } from "react-i18next";

import { WorkflowTab } from "./WorkflowDetail/WorkflowTab";
import { SubstationTab } from "./WorkflowDetail/SubstationTab";

import { TabView } from "../shared/TabView";

import type { WorkflowReducer } from "./workflowReducer";
import { MeasurementsOrderTab } from "./WorkflowDetail/MeasurementsOrderTab";

interface Props {
  workflowReducer: WorkflowReducer;
  editMode?: boolean;
  isLoading?: boolean;
}

export function WorkflowUI(props: Props) {
  const { t } = useTranslation();

  return (
    <>
      {!props.isLoading && props.workflowReducer.state.workflow && (
        <>
          <TabView tabLabels={[t("workflows.workflow"), t("substations.substation"), t("workflows.measurements")]}>
            <WorkflowTab workflow={props.workflowReducer.state.workflow} editMode={props.editMode} />
            <SubstationTab workflowReducer={props.workflowReducer} editMode={props.editMode} />
            <MeasurementsOrderTab workflowReducer={props.workflowReducer} editMode={props.editMode} />
          </TabView>
        </>
      )}
    </>
  );
}
